import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

const DetalleNivelCF = props => {
  return (
    <option value={props.elemento.cicloFact}>{props.elemento.cicloFact}</option>
  )
};

const ListaCF = ({styles, list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const NivelDetalleES = list.map((elemento, _id) => <DetalleNivelCF styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="cicloFact" id="miListaCF" value={(permiteUpdate||!idLista.cicloFact)?argsDocum.cicloFact:idLista.cicloFact} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {NivelDetalleES}
      </select>
    </div>
  )
};

class VerRFact2 extends React.Component {
  state={
    argsDocum: {
      prefijo: this.props.idLista.prefijo?this.props.idLista.prefijo:"",
      factInicial: this.props.idLista.factInicial,
      factFinal: this.props.idLista.factFinal,
      proxFact: this.props.idLista.proxFact,
      cicloFact: this.props.idLista.cicloFact,
      fecha: this.props.idLista.fecha,
      numResolucion: this.props.idLista.numResolucion,
      observaciones: this.props.idLista.observaciones,
      estadoRangoFact: this.props.idLista.estadoRangoFact,
      _id: this.props.idLista._id
    },
    confirmaAct: false,
    open: false
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      if(ev.target.name !== "factInicial"&&ev.target.name !== "factFinal"){
        const argsDocum = this.state.argsDocum
        if(ev.target.name === "estadoRangoFact"){
          if(argsDocum.estadoRangoFact === true){
              argsDocum[ev.target.name] = false
          }else{
              argsDocum[ev.target.name] = true
          }
        }else{
          argsDocum[ev.target.name] = ev.target.value
        }
        this.setState({argsDocum});
      }
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, confirmaAct, open} = this.state;
    // console.log(argsDocum)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Rango de facturación
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <Form.Field>
                    <label style={this.props.styles.label}>Prefijo</label>
                    <input style={this.props.styles.input} autoComplete="off" name="prefijo" id="prefijo" value={this.props.permiteUpdate?argsDocum.prefijo:this.props.idLista.prefijo?this.props.idLista.prefijo:""} onChange={this.handleChange} placeholder='Prefijo' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'prefijo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Número de la factura inicial</label>
                    <input type='number' step="1" min="1" style={this.props.styles.input} autoComplete="off" name="factInicial" id="factInicial" value={argsDocum.factInicial} placeholder='Inicial' onChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Número de la factura final</label>
                    <input type='number' step="1" min="1" style={this.props.styles.input} autoComplete="off" name="factFinal" id="factFinal" value={argsDocum.factFinal} placeholder='Final' onChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Número de la última factura</label>
                    <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="proxFact" id="proxFact" value={argsDocum.proxFact} placeholder='Ultima' onChange={this.handleChange}/>
                  </Form.Field>

                  <Form.Field>
                    <label style={this.props.styles.label}>Ciclo de facturación</label>
                    <ListaCF list={this.props.listaCF} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>

                  <Form.Field>
                    <label style={this.props.styles.label}>Fecha</label>
                    <input style={this.props.styles.input} type='date' name="fecha" id="fecha" value={this.props.permiteUpdate?argsDocum.fecha.substr(0, 10):this.props.idLista.fecha.substr(0, 10)} onChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Resolución</label>
                    <input style={this.props.styles.input} autoComplete="off" name="numResolucion" id="numResolucion" value={this.props.permiteUpdate?argsDocum.numResolucion:this.props.idLista.numResolucion} onChange={this.handleChange} placeholder='Resolución' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'numResolucion'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Observaciones</label>
                    <input style={this.props.styles.input} autoComplete="off" name="observaciones" id="observaciones" value={this.props.permiteUpdate?argsDocum.observaciones:this.props.idLista.observaciones} onChange={this.handleChange} placeholder='Observaciones' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'observaciones'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Inactivo / Activo</label>
                    <Form.Checkbox name="estadoRangoFact" id="estadoRangoFact" className='ui fitted toggle checkbox' checked={argsDocum.estadoRangoFact} onChange={this.handleChange}/>
                  </Form.Field>

                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>

                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }

              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default VerRFact2
